import { render, staticRenderFns } from "./SalidasFormProductos.vue?vue&type=template&id=53b2d8c6&scoped=true&"
import script from "./SalidasFormProductos.vue?vue&type=script&lang=js&"
export * from "./SalidasFormProductos.vue?vue&type=script&lang=js&"
import style0 from "./SalidasFormProductos.vue?vue&type=style&index=0&id=53b2d8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2d8c6",
  null
  
)

export default component.exports